import { MutationTree } from 'vuex'
import { AlertApi, AlertState, StoreError } from './types'

export const mutations: MutationTree<AlertState> = {
  ALERTS_UPDATED (state, payload: AlertApi[]) {
    state.error = { state: false }
    state.alerts = payload
  },
  STORE_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
